import $ from "jquery";
import deps from "../dependencies";

const Flickity = deps.flickity;

/**
 * Equal card heights inside a Flickity slider.
 *
 * Flickity positions its cells absolutely and sizes the viewport to the tallest
 * one, so a card cannot take that height with CSS: `height: 100%` measures against
 * a viewport whose height is derived from the cell itself, which collapses the
 * slider. Measuring in JS and writing a `min-height` on the shorter cards keeps the
 * tallest card leading, so the viewport height never changes and there is no loop.
 *
 * In a grid the browser already stretches the cards; only sliders need this.
 *
 * Prefer CSS where the card allows it: a card whose height is fully determined — a fixed
 * aspect ratio on the image plus a set number of lines for every text block — is equal
 * everywhere without measuring, and does not jump once on load. `excursion-item` works that
 * way. Add a card to CARDS only when its height genuinely varies with its content.
 */

const CARDS = [".sb_template-item", ".sb_accommodation-item", ".sb_sdg-item"];
const CARD = CARDS.join(", ");
const SLIDER = ".flickity-enabled";

/**
 * Give every card in one slider the height of its tallest card.
 */
function equaliseSlider(slider) {
    // A card the visitor opened (`s_is-expanded`, e.g. "Lees meer") keeps its own
    // height: levelling the rest to it would stretch every closed card to the length
    // of one open text.
    $(slider).find(CARD).filter(".s_is-expanded").css("min-height", "");

    const $cards = $(slider).find(CARD).not(".s_is-hidden, .s_is-expanded");

    // Measure the natural height first — a min-height from an earlier pass would
    // otherwise become the new maximum and the cards would only ever grow.
    $cards.css("min-height", "");

    let tallest = 0;

    $cards.each(function () {
        tallest = Math.max(tallest, this.offsetHeight);
    });

    if (tallest > 0) {
        $cards.css("min-height", `${tallest}px`);
    }

    // Flickity sized the viewport before this pass ran, so it still holds the height of the
    // tallest card from before the cards were levelled. Without this recalculation a strip of
    // empty space stays behind under the row.
    const flickity = Flickity.data(slider);

    if (flickity) {
        flickity.resize();
    }
}

/**
 * Run over every slider that holds cards.
 */
function equaliseAll() {
    $(SLIDER).each(function () {
        if ($(this).find(CARD).length > 0) {
            equaliseSlider(this);
        }
    });
}

let resizeTimer = null;

$(window).on("resize orientationchange", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(equaliseAll, 150);
});

// Flickity initialises after document ready and images settle later, so measure on
// load as well. Sections that swap cards in over AJAX can trigger the same pass.
$(window).on("load", equaliseAll);
$(document).on("slider-cards:measure template-cards:measure", equaliseAll);

export { equaliseAll };
